import api from "../../lib/api";

export default {
  namespaced: true,
  state: {
    list: [],
    roles: ["super_admin", "admin", "site_manager"],
    loading: true,
    posting: false,
    statusing: false,
    isAddOrEdit: false,
    user: {
      id: 0,
      username: "",
      password: "",
      role: "", // super_admin / admin / site_manager
      site: ""
    }
  },
  mutations: {
    SET_USERS(state, users) {
      state.list = users;
    },
    SET_IS_ADD_OR_EDIT(state, isAddOrEdit) {
      state.isAddOrEdit = isAddOrEdit;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_POSTING(state, posting) {
      state.posting = posting;
    },
    SET_STATUSING(state, statusing) {
      state.statusing = statusing;
    },
    SET_USER(state, user) {
      state.user = user;
    },
    RESET_USER(state) {
      state.user = {
        id: 0,
        username: "",
        password: "",
        role: "",
        site: "",
        status: 1
      };
    }
  },
  actions: {
    setLoading({ commit }, loading) {
      commit("SET_LOADING", loading);
    },
    setIsAddOrEdit({ commit }, isAddOrEdit) {
      commit("SET_IS_ADD_OR_EDIT", isAddOrEdit);
    },
    async saveUser({ commit, dispatch }, user) {
      commit("SET_POSTING", true);
      if (user.id === 0) {
        await api.post("/users", { user });
      } else {
        await api.put(`/users/${user.id}`, { user });
      }
      await dispatch("getUsers");
      commit("SET_POSTING", false);
      commit("SET_IS_ADD_OR_EDIT", false);
      commit("RESET_USER");
    },
    async getUserById({}, id) {
      const response = await api.get(`/users/${id}`);
      return response.data;
    },
    async deleteUser({ dispatch }, id) {
      await api.delete(`/users/${id}`);
      await dispatch("getUsers");
    },
    async toggleStatus({ commit, dispatch }, user) {
      commit("SET_STATUSING", true);
      await api.patch(`/users/${user.id}`, {
        status: !user.status
      });
      await dispatch("getUsers");
      commit("SET_STATUSING", false);
    },
    async editUser({ dispatch, commit }, id) {
      commit("SET_USER", await dispatch("getUserById", id));
      commit("SET_IS_ADD_OR_EDIT", true);
    },
    async getUsers({ commit }, { bypass = false } = {}) {
      if (!bypass) commit("SET_LOADING", true);
      const response = await api.get("/users");
      commit("SET_USERS", response.data);
      if (!bypass) commit("SET_LOADING", false);
    }
  },
  getters: {
    user: state => state.user,
    users: state => state.list,
    roles: state => state.roles,
    isAddOrEdit: state => state.isAddOrEdit,
    loading: state => state.loading,
    posting: state => state.posting,
    statusing: state => state.statusing
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/user.js